import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'corner-down-left-double',
  'IconCornerDownLeftDouble',
  [
    ['path', { d: 'M19 5v6a3 3 0 0 1 -3 3h-7', key: 'svg-0' }],
    ['path', { d: 'M13 10l-4 4l4 4m-5 -8l-4 4l4 4', key: 'svg-1' }],
  ],
);
